<template>
  <div class="textballoon" ref="wrapper">
    <div class="textballoon__text-wrap">
      <div class="textballoon__text" ref="text" :class="cssClass" :style="cssVars">{{text}}</div>
    </div>
    <div class="textballoon__arrow" :style="arrowCssVars" :class="cssClass">
      <svg
        width="72px"
        height="6px"
        viewBox="0 0 72 6"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        ref="arrow"
      >
        <g id="Artboard" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <polygon
            id="Triangle"
            :fill="textBackground"
            transform="translate(36.500000, 3.000000) scale(1, -1) translate(-36.500000, -3.000000) "
            points="36.5 0 40 6 33 6"
          />
        </g>
      </svg>
    </div>
    <invader
      :speed="speed"
      :isPaused="isLocalPaused"
      :fill="fill"
      :showDeadWhenPaused="false"
      class="textballoon__invader"
    />
  </div>
</template>

<script>
import Invader from "./Invader.vue";

export default {
  name: "Textballoon",
  data() {
    return {
      textWidth: 0,
      containerWidth: 0,
      arrowWidth: 0,
      isAnimating: false,
      isLocalPaused: this.isPaused
    };
  },
  mounted() {
    this.updateTextWidth();
    this.updateContainerWidth();
    this.updateArrowWidth();
    setTimeout(() => {
      this.isAnimating = true;
    }, 500);
  },
  components: {
    Invader
  },
  props: {
    speed: {
      type: Number,
      required: true
    },
    isPaused: {
      type: Boolean,
      required: true
    },
    fill: {
      type: String,
      default: "#ab90c9"
    },
    text: {
      type: String,
      default: ""
    },
    textBackground: {
      type: String,
      default: "#5C2D91"
    }
  },
  computed: {
    cssVars() {
      return {
        "--max-translation": `${(this.containerWidth - this.textWidth) * .5}px`,
        "--min-translation": `${(this.containerWidth - this.textWidth) * -.5}px`,
        "--speed": `${this.speed}s`,
        "background-color": this.textBackground
      };
    },
    arrowCssVars() {
      return {
        "--max-translation": `${(this.containerWidth - this.arrowWidth) * .5}px`,
        "--min-translation": `${(this.containerWidth - this.arrowWidth) * -.5}px`,
        "--speed": `${this.speed}s`
      };
    },
    cssClass() {
      return {
        animate: this.isAnimating,
        paused: this.isAnimating && this.isLocalPaused
      };
    },
    invader() {
      return this.originalInvader;
    }
  },
  methods: {
    updateTextWidth() {
      this.textWidth = this.$refs.text.clientWidth;
    },
    updateContainerWidth() {
      this.containerWidth = this.$refs.wrapper.clientWidth;
    },
    updateArrowWidth() {
      this.arrowWidth = this.$refs.arrow.clientWidth;
    }
  },
  watch: {
    text(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isLocalPaused = true;
        setTimeout(() => {
          this.updateTextWidth();
          this.isLocalPaused = false;
        }, 10);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.textballoon {
  // font-size: 0px;
  line-height: 0;
  text-align: center;
  &__text {
    display: inline-block;
    line-height: 35px;
    padding: 0 15px;
    background-color: $eminence;
    color: $white;
  }

  &__text-wrap {
    display: inline-block;
    width: 100%;
  }

  &__arrow {
    display: inline-block;
    height: 6px;
    clear: both;

    &.animate {
      animation-name: arrowAnimation;
      animation-duration: var(--speed);
      animation-iteration-count: infinite;
      animation-timing-function: ease;
      animation-play-state: running;
    }

    &.paused {
      animation-play-state: paused;
    }

    svg {
      display: block;
    }
  }

  .textballoon__text {
    display: inline-block;
    // margin-bottom: 5px;
    &.animate {
      animation-name: textBalloonAnimation;
      animation-duration: var(--speed);
      animation-iteration-count: infinite;
      animation-timing-function: ease;
      animation-play-state: running;
    }

    &.paused {
      animation-play-state: paused;
    }
  }

  &__invader {
    margin: 0;
  }
}

@keyframes textBalloonAnimation {
  0% {
    transform: translateX(0);
    -webkit-transform: translateX(0);
  }

  25% {
    transform: translateX(var(--min-translation));
    -webkit-transform: translateX(var(--min-translation));
  }

  75% {
    transform: translateX(var(--max-translation));
    -webkit-transform: translateX(var(--max-translation));
  }

  100% {
    transform: translateX(0);
    -webkit-transform: translateX(0);
  }
}

@keyframes arrowAnimation {
  0% {
    transform: translateX(0);
    -webkit-transform: translateX(0);
  }

  25% {
    transform: translateX(var(--min-translation));
    -webkit-transform: translateX(var(--min-translation));
  }

  75% {
    transform: translateX(var(--max-translation));
    -webkit-transform: translateX(var(--max-translation));
  }

  100% {
    transform: translateX(0);
    -webkit-transform: translateX(0);
  }
}
</style>